export default "/images/calendar-plus.svg?1fdd57bc9edd7a2dabff2ae1ec112422";